import { AccessToken } from '../access-token';
import { decodeJWTToken } from '../access-token/utils';
import { SSOService } from './SSOService';
import { b2cSSOService } from './vendors/b2c';
import { zitadelSSOService } from './vendors/zitadel';

class CurrentSSOService {
  private ssoService: SSOService | null = null;

  public initializeSSOService() {
    const token = AccessToken.getToken();
    const tokenData = decodeJWTToken(token);

    if (tokenData?.iss?.includes('b2clogin.com')) {
      this.ssoService = b2cSSOService;
    } else if (tokenData?.iss?.includes('zitadel')) {
      this.ssoService = zitadelSSOService;
    }
  }

  public setSSOService(ssoService: SSOService | null) {
    this.ssoService = ssoService;
  }

  public getSSOService(): SSOService | null {
    return this.ssoService;
  }
}

export const currentSSOService = new CurrentSSOService(); 